import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, GitBranch, AlertTriangle, Code, ShieldCheck, ArrowRight } from "lucide-react";

const topics = [
  { icon: BookOpen, t: "Onboarding", d: "Add your first domain and route DMARC reports." },
  { icon: ShieldCheck, t: "DNS Setup", d: "Configure SPF, DKIM, and DMARC records correctly." },
  { icon: GitBranch, t: "SPF Troubleshooting", d: "Resolve lookup limit and include-chain explosion issues." },
  { icon: AlertTriangle, t: "Enforcement Rollout", d: "Move from p=none to p=reject without breaking mail." },
  { icon: Code, t: "API Reference", d: "Full REST + webhook documentation and examples." },
  { icon: BookOpen, t: "BIMI Guide", d: "Logo validation, VMC requirements, mailbox previews." },
];

export default function Docs() {
  return (
    <div>
      <section className="pt-20 pb-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-600 mb-5">Documentation</div>
          <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] ink">
            Clear, calm <span className="font-serif italic font-normal">documentation.</span>
          </h1>
          <p className="mt-7 text-lg ink-soft leading-relaxed">
            Operationally clear, telemetry-driven references for every product surface.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map(({ icon: Icon, t, d }) => (
            <Link to="/docs" key={t} className="panel p-7 hover:border-orange-200 hover:shadow-sm transition-all group">
              <div className="h-11 w-11 rounded-lg bg-orange-50 flex items-center justify-center mb-5 group-hover:bg-orange-100 transition-colors">
                <Icon className="h-5 w-5 text-orange-600" strokeWidth={2} />
              </div>
              <div className="font-display text-lg font-bold ink">{t}</div>
              <p className="mt-2 text-sm ink-soft">{d}</p>
              <div className="mt-5 flex items-center gap-1 text-xs font-medium text-orange-600">
                Read <ArrowRight className="h-3 w-3" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
